// externals

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as compositeSelectors from '@makemydeal/dr-dash-store/selectors/compositeSelectors';
import type { DealHistory } from '@makemydeal/dr-dash-types';

// consts
import { CAPITALIZED_TAXES } from '../../constants';

// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';

// components
import { DealSummaryItemWrapper } from '../common/DealSummaryItemWrapper';

export type TotalTaxProps = {
    deal?: DealHistory;
    hasDelta?: boolean;
};

const LeaseTotalTax = ({ deal, hasDelta = false }: TotalTaxProps) => {
    const useDealRootSelector = createDealRootSelector(deal, 'LeaseTotalTax');
    const totalTax = useDealRootSelector(compositeSelectors.getCapitalizedTax, 'capitalizedTax');

    return <DealSummaryItemWrapper hasDelta={hasDelta} label={CAPITALIZED_TAXES} value={formatDollarsAndCents(totalTax)} />;
};

export default LeaseTotalTax;
